import { Link } from 'react-router-dom';
import Newsletter from '@/components/feature/Newsletter';

export default function CtaSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20of%20a%20warm%20evening%20scene%20of%20a%20mountain%20sect%20with%20lanterns%20and%20cranes%20returning%20home%2C%20cinnabar%20red%20and%20golden%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20cozy%20soft%20lighting%2C%20high%20detail%2C%20no%20text&width=1600&height=700&seq=cta-shixiong&orientation=landscape"
          alt="灯火温暖的山门与归来的仙鹤水墨画"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/50 to-black/40" />
      </div>
      <div className="relative z-10 mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 py-16 md:px-6 md:py-24 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="font-seal text-2xl text-accent-300">入我山门 · 一起嗑糖</span>
          <h2 className="mt-4 font-heading text-3xl font-bold leading-snug text-background-50 md:text-4xl">
            新一季开播在即，
            <br />
            别错过任何一口糖。
          </h2>
          <p className="mt-4 max-w-md text-sm leading-7 text-background-100/85">
            人物关系图谱、CP线脉络、师门高甜名场面持续整理中。订阅追更，第一时间收到更新提醒，也欢迎去「关于我们」了解本站。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/50 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/25"
          >
            了解本站 <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="rounded-xl border border-background-50/15 bg-background-50/10 p-6 backdrop-blur-md md:p-8">
          <Newsletter />
        </div>
      </div>
    </section>
  );
}